import type { IconProps } from './types'

export const AppLogoIcon = ({ className }: IconProps) => {
  return (
    <svg
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-hidden="true"
    >
      <rect width="48" height="48" rx="16" fill="url(#logo-bg)" />
      <path
        d="M7 20C7 13.9249 11.9249 9 18 9H41V28C41 34.0751 36.0751 39 30 39H7V20Z"
        fill="white"
        fillOpacity="0.14"
      />
      <path
        d="M7 25C7 21.134 10.134 18 14 18H27V31C27 34.866 23.866 38 20 38H7V25Z"
        fill="white"
        fillOpacity="0.2"
      />
      <defs>
        <linearGradient id="logo-bg" x1="4.5" y1="4.5" x2="44" y2="44" gradientUnits="userSpaceOnUse">
          <stop stopColor="#63E2FF" />
          <stop offset="0.48" stopColor="#2563EB" />
          <stop offset="1" stopColor="#6D28D9" />
        </linearGradient>
      </defs>
    </svg>
  )
}
